import React from "react";
import { Link } from "react-router-dom";
import signature from "../../Assets/Signature/signature (1).png";
import { BsGithub } from "react-icons/bs";
import {
  FaFacebook,
  FaLinkedin,
  FaFacebookMessenger,
  FaTelegram,
} from "react-icons/fa";

const Navbar = () => {
  return (
    <div className="navbar  lg:px-[150px]">
      <div className="navbar-start">
        <div className="dropdown">
          <label tabIndex={0} className="btn btn-ghost lg:hidden">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h8m-8 6h16"
              />
            </svg>
          </label>
          <ul
            tabIndex={0}
            className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52"
          >
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About</Link>
            </li>
            <li>
              <Link to="/education">Education</Link>
            </li>
            <li>
              <Link to="/projects">Projects</Link>
            </li>
            <li>
              <Link to="/blog">Blog</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
          </ul>
        </div>
        <Link to="/" className="">
          <div className="h-10">
            <img className="h-full" src={signature} alt="" />
          </div>
        </Link>
      </div>
      <div className="navbar-center hidden lg:flex">
        <ul className="menu menu-horizontal px-1">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/about">About</Link>
          </li>
          <li>
            <Link to="/education">Education</Link>
          </li>
          <li>
            <Link to="/projects">Projects</Link>
          </li>
          <li>
            <Link to="/blog">Blog</Link>
          </li>
          <li>
            <Link to="/contact">Contact</Link>
          </li>
        </ul>
      </div>
      <div className="navbar-end">
        <div className="flex gap-2 mr-3">
          <a
            className="text-2xl md:text-4xl"
            href="https://www.linkedin.com/in/siam-shahriar/"
            target="_blank"
            rel="noreferrer"
          >
            <FaLinkedin></FaLinkedin>
          </a>
          <a
            className="text-2xl md:text-4xl"
            href="https://github.com/siamshahriar"
            target="_blank"
            rel="noreferrer"
          >
            <BsGithub></BsGithub>
          </a>{" "}
          <a
            className="text-2xl md:text-4xl"
            href="https://m.me/mdshahriarrahman.siam/"
            target="_blank"
            rel="noreferrer"
          >
            <FaFacebookMessenger></FaFacebookMessenger>
          </a>
          <a
            className="text-2xl md:text-4xl"
            href="https://t.me/siaamdiu"
            target="_blank"
            rel="noreferrer"
          >
            <FaTelegram></FaTelegram>
          </a>
        </div>
        <a
          href="https://drive.google.com/file/d/1n0G8yXAuZLZvbOaiHhEHIzpdCkk9FPVj/view?usp=share_link"
          target="_blank"
          className="btn btn-success text-gray-900"
          rel="noreferrer"
        >
          Resume
        </a>
      </div>
    </div>
  );
};

export default Navbar;
